import HeaderBack from "@/components/fragments/HeaderBack";
import PaymentFeature from "@/features/Payment";

export default function PaymentPage() {
  return (
    <main className="md:w-[80vw] lg:w-[70vw] mx-auto pb-25 ">
      <HeaderBack text="Pemayaran Tunai" url="/catalog" />
      <PaymentFeature />
    </main>
  );
}
